import { skipToken } from "@tanstack/react-query";
import { useCurrentWorkspaceId } from "@v2/contexts/WorkspaceDashboardContext";
import { agentBillingRouter } from "@v2/trpc/routes/agentBilling";

export function useRateCards() {
  const workspaceId = useCurrentWorkspaceId();

  const { data, isLoading } =
    agentBillingRouter.subscription.findRateCards.useQuery(
      workspaceId ? { workspaceId } : skipToken,
    );

  return {
    rateCards: data ?? null,
    isLoading,
  };
}
